// extracted by mini-css-extract-plugin
export default {"container":"styles_container__F1HZG","mainSection":"styles_mainSection__IU-f7"};